import apiClient from './client';

export interface KeepStatus {
  connected: boolean;
  email?: string;
  last_used_at?: string;
  collaborators?: string[];
}

export interface KeepSetupInput {
  email: string;
  master_token: string;
  collaborators?: string[];
}

export interface KeepExportInput {
  note_title: string;
  unchecked_only?: boolean;
  collaborators?: string[];
}

export interface KeepUpdateSettingsInput {
  collaborators: string[];
}

export interface KeepExportResult {
  exported: boolean;
  note_title: string;
  item_count: number;
}

export const googleKeepApi = {
  getStatus: async () => {
    const response = await apiClient.get<{ data: KeepStatus }>('/google-keep');
    return response.data.data;
  },

  setup: async (data: KeepSetupInput) => {
    const response = await apiClient.post<{ data: KeepStatus }>('/google-keep/setup', data);
    return response.data.data;
  },

  disconnect: async () => {
    await apiClient.delete('/google-keep/setup');
  },

  updateSettings: async (data: KeepUpdateSettingsInput) => {
    const response = await apiClient.patch<{
      data: { collaborators: string[] };
    }>('/google-keep', data);
    return response.data.data;
  },

  exportToKeep: async (data: KeepExportInput) => {
    const response = await apiClient.post<{ data: KeepExportResult }>('/google-keep/export', data);
    return response.data.data;
  },
};
